import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import MaintenanceScheduled from "./MaintenanceScheduled";

const ScheduledMaintenancePage = () => {
  return (
    <NavHeightAdjust>
      <MaintenanceScheduled />
    </NavHeightAdjust>
  );
};

export default ScheduledMaintenancePage;
